// @ts-ignore
import { styled } from '@mui/material';
import { apiGetFactor } from 'api/factorApi';
import BasicButton from 'components/BasicInputs/BasicButton';
import useForeignFactorPrint from 'components/Factor2/print/useForeignFactorPrint';
import { useEffect, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { store } from 'store/store';
const ItemContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: "36px",
}));
const ForeignPrint = ({
    factorId,
    factorType,
    autoPrint,
}: {
    factorId: string | number;
    factorType: string;
    autoPrint?: boolean;
}) => {
    const { dispatch, getState } = store
    const token = getState().businessReducer.business?.token;
    const [factorIsFetched, setFactorIsFetched] = useState(false);
    const [remittance, setRemittance] = useState<any>(null);

    const callBack = (response:any) => {
        return setFactorIsFetched(true);
       

    }
    useEffect(() => {

        dispatch(apiGetFactor(factorId, factorType, token, callBack));

        return () => {

        }
    }, [])
    useEffect(() => {
        if (factorIsFetched && autoPrint) printRef.current.handleClick();
    }, [factorIsFetched]);
    const printRef = useRef<any>(null);

    const { content, contentRef } = useForeignFactorPrint({remittance})
    return (
        <ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
            <div className="hidden">{content}</div>
            <ReactToPrint
                ref={printRef}
                trigger={() => (
                    <BasicButton fullWidth variant="outlined">
                        <span>print</span>
                    </BasicButton>
                )}
                content={() => contentRef.current}
            />
        </ItemContainer>

    )
}

export default ForeignPrint;